/* Project Import will be here */
import { getErrorObject } from "../../utilities/utils";
import { getDigitalContentListApi } from "services/digitalContent";
/* Project Import will be here */

export const types = {
    DIGITAL_CONTENT_LIST_REQUEST: "digitalContent/digitalContentRequest",
    DIGITAL_CONTENT_LIST_SUCCESS: "digitalContent/digitalContentSuccess",
    DIGITAL_CONTENT_LIST_FAILURE: "digitalContent/digitalContentFailure",
};

let initialState = {
    isLoading: false,
    data: [],
    error: null
};

export const digitalContent = (state = initialState, action) => {
    switch (action.type) {
        case types.DIGITAL_CONTENT_LIST_REQUEST:
            return { ...state, isLoading: true };
        case types.DIGITAL_CONTENT_LIST_SUCCESS:
            return { ...state, ...action.payload, error: null, isLoading: false };
        case types.DIGITAL_CONTENT_LIST_FAILURE:
            return { ...state, isLoading: false, error: action.payload.error };
        default:
            return state;
    }
};

/* Get digital content image or file list */
export const getDigitalContentList = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.DIGITAL_CONTENT_LIST_REQUEST });
        try {
            const response = await getDigitalContentListApi();

            dispatch({
                type: types.DIGITAL_CONTENT_LIST_SUCCESS,
                payload: { data: response.data.Data }
            });
        }
        catch (error) {
            const { message } = getErrorObject(error);
            dispatch({
                type: types.DIGITAL_CONTENT_LIST_FAILURE,
                payload: { error: message }
            });
        }
    }
};